<template>
  <div>
    <div>
      <Table
        small
        :items="tableArticles"
        :fields="articleFields"
        :responsive="true"
        :striped="true"
        :hover="true"
        @sort-changed="onSortChanged"
        :tbody-tr-attr="rowIdentifierArticles"
        :show-empty="true"
        :aria-label="$t('transactionDetails.label.paymentDetailsTable')"
      >
        <template #custom-foot>
          <tr>
            <td class="text-left" colspan="2"><b>{{ $t('transactionDetails.tableColumn.total') }}</b></td>
            <td class="text-right"><b>{{ transaction.formattedPaymentTotal }}</b></td>
          </tr>
        </template>
      </Table>
    </div>
    <div v-if="config.TRANSACTION_HISTORY.showModalPaymentDetails && typeof transaction.paymentsList !== 'undefined' && transaction.paymentsList.length > 0">
      <Table
        small
        :items="transaction.paymentsList"
        :fields="paymentFields"
        :responsive="true"
        :striped="true"
        :hover="true"
        :tbody-tr-attr="rowIdentifierPaymentDetails"
        :show-empty="true"
        :aria-label="$t('transactionDetails.label.paymentDetailsTable')"
      >
      </Table>
    </div>
  </div>
</template>

<script>
import Table from "@/components/data-display/Table.vue";

export default {
  components: {Table},
  computed: {
    prepayment() {
      return this.transaction.prepayment;
    },
    config() {
      return window.config;
    },
    tableArticles() {
      // Compose the list for the Table: add prepayment row if needed
      const articles = this.transaction.articleslist ? [...this.transaction.articleslist] : [];
      if (this.prepayment) {
        articles.unshift({
          articleCode: 'prepayment',
          articleDescription: this.$t('transactionDetails.label.prepayment'),
          qtyWeight: 1,
          formattedPrice: this.getPrepaymentAmount(),
          formattedDiscountedPrice: undefined,
          amount: this.getPrepaymentAmount(),
        });
      }
      return articles;
    },
    articleFields() {
      return [
        {
          key: 'articleDescription',
          label: this.$t('transactionDetails.tableColumn.article'),
          sortable: false
        },
        {
          key: 'qtyWeight',
          label: this.$t('transactionDetails.tableColumn.quantity'),
          sortable: false,
          class: 'text-right'
        },
        {
          key: 'amount',
          label: this.$t('transactionDetails.tableColumn.amount'),
          sortable: false,
          class: 'text-right',
          formatter: (value, key, item) => item.formattedDiscountedPrice ? item.formattedDiscountedPrice : item.formattedPrice,
        }
      ];
    },
    paymentFields() {
      return [
        {
          key: 'paymentDescription',
          label: this.$t('transactionDetails.tableColumn.paymentMethod'),
          class: 'text-left'
        },
        {
          key: 'formattedAmount',
          label: this.$t('transactionDetails.tableColumn.amount'), class: 'text-right' }
      ];
    },
  },
  props: {
    transaction: {
      type: Object,
      required: true
    },
  },
  methods: {
    getPrepaymentAmount() {
      return this.transaction.paymentsList !== undefined && this.transaction.paymentsList.length > 0 ? this.transaction.paymentsList.filter(function (x) {
        return x.isPrepayment
      })[0].formattedAmount : undefined;
    },
    onSortChanged({sortBy, sortDesc}) {
      this.sortBy = sortBy;
      this.sortDesc = sortDesc;
    },
    rowIdentifierArticles(item) {
      // todo PR - Text : Rows tell the text: "Artikel, aufladung", but i dont think "aufladung" is an article. (could be wrong, optionaly just ignore)
      return {
        'title': this.$t('transactionDetails.tooltip.article',[item.articleDescription])
      }
    },
    rowIdentifierPaymentDetails(item) {
      // todo PR - Text : Rows tell the text: "Artikel, Kundenkarte"(ex), but i dont think payment is an article. (could be wrong, optionaly just ignore)
      return {
        'title': this.$t('transactionDetails.tooltip.article', [item.paymentDescription])
      }
    },
  },
}
</script>
